// SEO helpers + Schema.org JSON-LD generators
export function eventJsonLd(evento, locale, baseUrl) {
  if (!evento) return null;
  const startDate = `${evento.data}T${(evento.orario || '21:00')}:00+02:00`;
  return {
    '@context': 'https://schema.org',
    '@type': 'Event',
    name: evento.titolo,
    startDate,
    eventStatus: 'https://schema.org/EventScheduled',
    eventAttendanceMode: 'https://schema.org/OfflineEventAttendanceMode',
    description: stripHtml(evento.descrizione || ''),
    image: evento.locandina ? [evento.locandina] : undefined,
    url: `${baseUrl}/eventi/${evento.slug}`,
    location: locale ? {
      '@type': 'Place',
      name: locale.nome,
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Roma',
        addressRegion: 'RM',
        addressCountry: 'IT',
        streetAddress: locale.indirizzo || `${locale.zona}, Roma`,
      }
    } : undefined,
    offers: evento.link_acquisto ? {
      '@type': 'Offer',
      url: evento.link_acquisto,
      price: (evento.prezzo_ingresso || '').replace(/[^0-9.,]/g, '') || undefined,
      priceCurrency: 'EUR',
      availability: 'https://schema.org/InStock',
    } : undefined,
    organizer: locale ? { '@type': 'Organization', name: locale.nome } : undefined,
  };
}

export function stripHtml(s) {
  if (!s) return '';
  return s.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
}

export function truncate(s, n = 160) {
  const t = stripHtml(s);
  return t.length > n ? t.slice(0, n - 1) + '…' : t;
}

export function zoneSlug(zona) {
  return (zona || '').toLowerCase().replace(/\s+/g, '-');
}

export function zoneFromSlug(slug, zones) {
  if (!slug) return '';
  const target = slug.toLowerCase();
  return zones.find((z) => zoneSlug(z) === target) || '';
}
